import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../formStyles.css"; // Import the general form styles

function ChangePassword() {
  const { t } = useTranslation();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const [errorMessage, setErrorMessage] = useState(""); // State for error messages
  const user = useSelector((state) => state.auth.user); // Retrieve user data
  const userId = user?.id; // Safely retrieve user ID

  const validatePassword = (password) => {
    const uppercase = /[A-Z]/.test(password);
    const lowercase = /[a-z]/.test(password);
    const number = /\d/.test(password);
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const criteriaCount = [uppercase, lowercase, number, specialChar].filter(
      Boolean
    ).length;

    return criteriaCount >= 2; // Must meet at least two criteria
  };

  const handleChangePassword = async () => {
    setErrorMessage(""); // Reset error message

    if (newPassword !== confirmPassword) {
      setErrorMessage(t("passwordMismatch"));
      return;
    }

    if (newPassword.length < 8) {
      setErrorMessage(t("passwordInvalidLength")); // Display message for short password
      return;
    }

    if (!validatePassword(newPassword)) {
      setErrorMessage(t("passwordInvalidComplexity")); // Display message for invalid complexity
      return;
    }

    setLoading(true); // Set loading state

    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/change_password.php`,
        {
          user_id: userId,
          old_password: currentPassword,
          new_password: newPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success(t("passwordChanged"));
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      }
    } catch (error) {
      setErrorMessage(t("passwordChangeFailed"));
      console.error("Password change error:", error); // Log error for debugging
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="form-container">
      <h2>{t("changePassword")}</h2>
      <label>
        {t("currentPassword")}:
        <input
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          aria-label={t("currentPassword")} // Accessibility
        />
      </label>
      <label>
        {t("newPassword")}:
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          aria-label={t("newPassword")} // Accessibility
        />
      </label>
      <label>
        {t("confirmPassword")}:
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          aria-label={t("confirmPassword")} // Accessibility
        />
      </label>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
      <div className="p-4">
        <button onClick={handleChangePassword} disabled={loading}>
          {loading ? <span>Loading...</span> : t("updatePassword")}
        </button>
      </div>
    </div>
  );
}

export default ChangePassword;
